<template>
    <v-dialog
        v-model="dialog"
        persistent
        eager
        :max-width="displayWidth"
        @keydown.esc="onEscapeKeydown"
    >
        <v-card role="region" aria-label="confirmation-dialog">
            <v-card-title class="py-2">
                <div>{{ title }}</div>
            </v-card-title>
            <v-card-text class="d-flex flex-direction-row">
                <div class="text-body-1">
                    <div
                        v-if="subMessage"
                        class="pb-3"
                        :class="options.subMessageClass"
                    >
                        {{ subMessage }}
                    </div>
                    <div :class="options.messageClass">{{ message }}</div>
                </div>
                <div v-show="options.showIcon" :style="iconStyle"></div>
            </v-card-text>
            <v-card-actions class="px-4 justify-end">
                <v-btn small outlined @click="onCancelClick">{{
                    options.cancelActionText
                }}</v-btn>
                <v-btn
                    v-show="options.confirmActionText.length"
                    small
                    color="primary"
                    @click="onConfirmClick"
                    >{{ options.confirmActionText }}</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { randomElement } from '@/common/helpers';

export default {
    name: 'ConfirmationPromiseDialog',
    data() {
        return {
            images: [
                'warning-40593_640.png',
                'aliens-28981_640.png',
                'slippery-151881_640.png',
                'traffic-sign-160656_640.png',
                'attention-307030_640.png',
                'school-30969_640.png',
                'stairs-155980_640.png',
                'stop-1829082_640.png',
                'error-3060993_640.png',
                'traffic-157617_640.png'
            ],
            selectedImage: '',
            dialog: false,
            resolve: null,
            reject: null,
            title: '',
            message: '',
            subMessage: '',
            options: {
                confirmActionText: 'Confirm',
                cancelActionText: 'Cancel',
                width: '450',
                showIcon: false,
                messageClass: '',
                subMessageClass: ''
            }
        };
    },
    computed: {
        displayImage() {
            return `/img/misc/${this.selectedImage}`;
        },
        iconStyle() {
            return {
                minWidth: '100px',
                backgroundImage: `url(${this.displayImage})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                minHeight: '100px'
            };
        },
        displayWidth() {
            if (this.$vuetify.breakpoint.smAndDown) {
                return '90%';
            }
            return this.options.width;
        }
    },
    watch: {
        dialog(value) {
            if (value === true) {
                this.suffleImage();
            }
        }
    },
    mounted() {
        this.suffleImage();
    },
    methods: {
        // ==================== Events ====================
        open(title, message, subMessage, options) {
            this.dialog = true;
            this.title = title;
            this.message = message;
            this.subMessage = subMessage;
            this.options = { ...this.options, ...options };
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        onCancelClick() {
            this.resolve(false);
            this.dialog = false;
        },
        onConfirmClick() {
            this.resolve(true);
            this.dialog = false;
        },
        onEscapeKeydown() {
            this.onCancelClick();
        },
        // =================== Others ======================
        suffleImage(index) {
            if (index >= 0) {
                this.selectedImage = this.images[index];
            } else {
                const lastImage = `${this.selectedImage}`;
                this.selectedImage = randomElement(this.images);
                while (
                    lastImage.toLowerCase() === this.selectedImage.toLowerCase()
                ) {
                    this.selectedImage = randomElement(this.images);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
